import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSlider from "../components/HeroSlider";
import InfoBar from "../components/InfoBar";
import AboutSection from "../components/AboutSection";
import StatsSection from "../components/StatsSection";
import ServicesSection from "../components/ServicesSection";
import AttorneysSection from "../components/AttorneysSection";
import AppointmentSection from "../components/AppointmentSection";
import TestimonialsSection from "../components/TestimonialsSection";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSlider />
        <InfoBar />
        <AboutSection />
        <StatsSection />
        <ServicesSection />
        <AttorneysSection />
        <TestimonialsSection />
        <AppointmentSection />
      </main>
      <Footer />
    </>
  );
}
